import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../actions/';
import FormPessoa from '../../components/fiadores/form-pessoa';
import CONSTANTS from '../../constants/index';

const mapStateToProps = (state, ownProps) => {
    let { indiceFiador, tipoPessoa } = ownProps;
    let dados = state.fiadores.listFiadores.find((item, indiceItem) => {
        return indiceItem === indiceFiador;
    });
    if(tipoPessoa == CONSTANTS._TIPO_PESSOA.CONJUGE){
        dados = dados.conjuge;
    }    
    
    
    return {
        listNacionalidade: state.listNacionalidade,
        listTpMoradia: state.listTpMoradia,
        ...dados
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onContinuarCPF(cpf, tipoPessoa, indiceFiador) {           
            dispatch(actions.getDadosFormFiadoresCPF(cpf, tipoPessoa, indiceFiador));
        },

        changeCampoGenericoFiador(campoState, valor, tipoPessoa, indiceFiador) {
            dispatch(actions.changeCampoGenericoFiador(campoState, valor, tipoPessoa, indiceFiador));
        },

        onEditarFiadorCPF(tipoPessoa, indiceFiador){
            dispatch(actions.onEditarFiadorCPF(tipoPessoa, indiceFiador));
        },

        onConsultaFiadorCEP(cep, tipoPessoa, indiceFiador){
            dispatch(actions.onConsultaFiadorCEP(cep, tipoPessoa, indiceFiador));
        },
       
        onChangeFiadorUF(uf, tipoPessoa, indiceFiador){           
            dispatch(actions.changeCampoGenericoFiador("uf", uf, tipoPessoa, indiceFiador));
            dispatch(actions.getCidadesByUfFiador(uf, tipoPessoa, indiceFiador));
           
        }
    };
};

const FormPessoaContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FormPessoa);


export default FormPessoaContainer;


// WEBPACK FOOTER //
// ./src/containers/fiadores/form-pessoa.js